export enum ClientCQAnalyticsState {
  NONE_COMPLETED_SOME_SENT,
  SINGLE_COMPLETED,
  MULTIPLE_COMPLETED
}

// NOTE: The keys between ClinicalAssessmentTypes & ClinicalAssessmentTypeDiagnosis should match
// NOTE: Assessments from the clinical assessments microservice are written with ALL-CAPS
// Assessments from the monolith are written with all_lower
export enum ClinicalAssessmentTypes {
  AUDIT_C = 'AUDIT-C',
  CSSRS_ADULTS = 'CSSRS-ADULTS',
  CSSRS_KIDS = 'CSSRS-KIDS',
  FUNCTIONAL = 'functional',
  GAD_7 = 'gad_7',
  PCL_5 = 'pcl_5',
  PHQ_9 = 'phq_9',
  PROMIS_ANGER = 'PROMIS-ANGER-PEDIATRIC',
  PROMIS_ANXIETY = 'PROMIS-ANXIETY-PEDIATRIC',
  S2BI = 'S2BI',
  THERAPEUTIC_ALLIANCE = 'therapeutic_alliance',
}

export enum ClinicalAssessmentTypeDiagnosis {
  PHQ_9 = 'depression',
  GAD_7 = 'anxiety',
}

export const enum ClientCQSymptomsChange {
  UNDEFINED = '',
  NO_SIGNIFICANT_CHANGE = 'No significant change',
  DECREASING = 'Decreasing',
  INCREASING = 'Increasing',
  MISALIGNED = 'Misaligned - check in',
  STRONG_ALLIANCE = 'Strong Alliance'
}

export const enum ClientCQStatusIndicatorColor {
  NEGATIVE = 'status-change-indicator-negative',
  NEUTRAL = 'status-change-indicator-neutral',
  POSITIVE = 'status-change-indicator-positive'
}

export enum AssessmentLinkLocations {
  TASK_LIST = 'task_list_link',
  DASHBOARD_LIST = 'dashboard_list_link',
  CLIENT_LIST = 'client_list_link',
  DIRECT_NAVIGATION = 'direct_navigation'
}
